import React, { useMemo } from 'react';
import { Card, CardContent, CardHeader, CardTitle } from '../ui/card';
import { MoveRight, TrendingDown, TrendingUp } from 'lucide-react';
import { ChildTooltip } from './ChildTooltip';

import { StatsPieChart } from './StatsPieChart';
interface Stats {
  current: number;
  trend: number;
  statuses?: Record<string, { value: number; color: string }>;
}
export const StatsCard = ({
  stats,
  totalOrders,
  title,
  label,
}: {
  stats: Stats;
  totalOrders: number;
  title: string;
  label: string;
}) => {
  const getColor = (trend: number, reverseTrend: boolean) => {
    if (reverseTrend) {
      return trend < 0 ? 'text-red-500' : trend > 0 ? 'text-green-500' : 'text-orange-500';
    }
    return trend < 0 ? 'text-green-500' : trend > 0 ? 'text-red-500' : 'text-orange-500';
  };

  const percentage = useMemo(() => {
    const percentage = (stats.current / totalOrders) * 100;

    return `${percentage.toFixed(2)} %`;
  }, [stats, totalOrders]);

  return (
    <Card className="flex ">
      <div>
        <CardHeader className="pb-2">
          <CardTitle className="flex justify-between items-center">{title}</CardTitle>
        </CardHeader>
        <CardContent className="flex justify-between items-center py-4">
          <div>
            <div className="flex justify-between">
              <p className="text-3xl font-bold">{percentage}</p>
              <div className={`${getColor(stats.trend, false)} mt-2`}>
                {stats.trend > 0 ? (
                  <>
                    <ChildTooltip title="More than previously">
                      <TrendingUp className="h-5 w-5" />
                    </ChildTooltip>
                  </>
                ) : stats.trend < 0 ? (
                  <>
                    <ChildTooltip title="Less than previously">
                      <TrendingDown className="h-5 w-5" />
                    </ChildTooltip>
                  </>
                ) : (
                  <>
                    <ChildTooltip title="The same as previously">
                      <MoveRight className="h-5 w-5" />
                    </ChildTooltip>
                  </>
                )}
              </div>
            </div>
            <div className="text-sm text-muted-foreground">
              {stats.current} {label}
            </div>
          </div>
        </CardContent>
      </div>

      <div className="mt-4">
        <StatsPieChart
          data={(Object.entries(stats.statuses) || []).map(([k, v]) => ({
            name: k,
            value: v.value,
            color: v.color,
          }))}
        />
      </div>
    </Card>
  );
};
